// app/javascript/controllers/sidebar_filter_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.sidebarElement = this.element;
    this.sidebarContent = this.sidebarElement.querySelector(".sidebar-content");
    this.closeButtons = this.sidebarElement.querySelectorAll(".close-sidebar");

    this.form = this.element.querySelector('form');

    if (this.form) {
      // Adjuntamos la validación principal al evento 'submit' del formulario.
      // Esto se disparará al hacer clic en el botón "Aplicar".
      this.form.addEventListener('submit', this.validateDates.bind(this));
    }
    // NOTA: Asegúrate de que no hay ningún document.addEventListener("click", this.handleOutsideClick.bind(this));
    // en ninguna parte de tu código, ya que es la causa más común de problemas con input type="date".
  }

  disconnect() {
    if (this.form) {
      this.form.removeEventListener('submit', this.validateDates.bind(this));
    }
    // NOTA: Lo mismo aplica para el removeEventListener en disconnect.
  }

  // --- MÉTODO AUXILIAR: Para parsear y validar fechas (reutilizable) ---
  // Este método SOLO PARSEA y VERIFICA la validez sintáctica y lógica de la fecha.
  // NO muestra alerts ni previene eventos.
  parseAndValidateDateHelper(dateString) {
    if (!dateString) return null;

    const parts = dateString.split('-');
    if (parts.length !== 3) return null; // No es formato YYYY-MM-DD

    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10); // 1-indexado
    const day = parseInt(parts[2], 10);

    const date = new Date(year, month - 1, day);

    // Verifica si la fecha creada realmente corresponde a los valores de entrada.
    if (
      date.getFullYear() !== year ||
      (date.getMonth() + 1) !== month || // Compara el mes 1-indexado
      date.getDate() !== day
    ) {
      return null; // Fecha no válida (ej. 31 de febrero)
    }
    return date;
  }


  // --- MÉTODO PRINCIPAL DE VALIDACIÓN (CON ALERTS y PREVENCIÓN) ---
  // Se ejecuta al "submit" del formulario (botón "Aplicar")
  // y cuando se intenta "Volver" desde la sección de fechas.
  validateDates(event) {
    const fechaDesdeField = document.getElementById('fecha_desde');
    const fechaHastaField = document.getElementById('fecha_hasta');

    const fechaDesde = fechaDesdeField ? fechaDesdeField.value : '';
    const fechaHasta = fechaHastaField ? fechaHastaField.value : '';

    const today = new Date();
    today.setHours(0, 0, 0, 0); // Normalizamos al inicio del día

    const parsedFechaDesde = this.parseAndValidateDateHelper(fechaDesde);
    const parsedFechaHasta = this.parseAndValidateDateHelper(fechaHasta);

    // --- Validaciones y ALERTS ---
    // Si alguna validación falla, se muestra el alert y se previene el submit (si el evento está presente)

    if (fechaDesde && !parsedFechaDesde) {
      if (event) event.preventDefault(); // Prevenir submit si el evento es real
      alert("La 'Fecha Desde' ingresada no es válida (ej. '31/02/2023'). Por favor, ingrese una fecha real.");
      return false; // Indica que la validación falló
    }

    if (fechaHasta && !parsedFechaHasta) {
      if (event) event.preventDefault();
      alert("La 'Fecha Hasta' ingresada no es válida (ej. '31/02/2023'). Por favor, ingrese una fecha real.");
      return false;
    }

    if (parsedFechaDesde && parsedFechaDesde > today) {
        if (event) event.preventDefault();
        alert("La 'Fecha Desde' no puede ser una fecha futura.");
        return false;
    }

    if (parsedFechaHasta && parsedFechaHasta > today) {
        if (event) event.preventDefault();
        alert("La 'Fecha Hasta' no puede ser una fecha futura.");
        return false;
    }

    if (parsedFechaDesde && parsedFechaHasta && parsedFechaDesde > parsedFechaHasta) {
      if (event) event.preventDefault();
      alert("La 'Fecha Desde' no puede ser posterior a la 'Fecha Hasta'.");
      return false;
    }

    return true; // Todas las validaciones pasaron
  }


  // --- MÉTODO PARA VALIDAR Y OCULTAR LA SECCIÓN AL CLIC EN "VOLVER" ---
  activarSegundoSidebar(e) {
    e.stopPropagation();
    e.preventDefault();

    const boton = e.currentTarget;
    const content = boton
      .closest(".filter_section") // Busca el padre más cercano con esta clase
      .querySelector(".sidebar-content");

    // Identificamos si el botón "Volver" pertenece a la sección de fechas.
    // Esto se hace buscando los campos de fecha dentro del 'sidebar-content' que se va a cerrar.
    const isDateSection = content.querySelector('#fecha_desde') && content.querySelector('#fecha_hasta');

    if (isDateSection) {
      // Si es la sección de fechas, ejecutamos la validación.
      // Pasamos 'null' como evento porque no es un 'submit' directo del formulario.
      if (!this.validateDates(null)) {
        // Si validateDates devuelve false (hubo un error y mostró un alert),
        // no cerramos el sidebar.
        return;
      }
    }

    // Si no es la sección de fechas, o si la validación de fechas pasó, procedemos a cerrar.
    if (content) {
      // Alternamos la visibilidad (oculto/mostrar)
      if (content.classList.contains("oculto")) {
        content.classList.remove("oculto");
        content.style.display = 'block';
      } else {
        content.classList.add("oculto");
        content.style.display = 'none';
      }
    }
  }


  closeTurboFrame(e) {
    e.stopPropagation();
    e.preventDefault();
    const turboFrame = document.querySelector("#sidebar");

    if (turboFrame) {
      turboFrame.innerHTML = "";
    }
  }

  updateParams(e) {
    let paramName, paramValue, button, buttonText;
    const inputElement = e.target;
    paramName = inputElement.name;
    paramValue = inputElement.value;

    if (paramName === 'fecha_asignada_desde' || paramName === 'fecha_asignada_hasta') {
      button = document.querySelector(`button[data-param="fecha"]`);
      const startDateInput = this.element.querySelector('input[name="fecha_asignada_desde"][id="fecha_desde"]');
      const endDateInput = this.element.querySelector('input[name="fecha_asignada_hasta"][id="fecha_hasta"]');

      const startDate = startDateInput ? startDateInput.value : '';
      const endDate = endDateInput ? endDateInput.value : '';

      const formattedStartDate = startDate ? startDate.split('-').reverse().join('/') : '';
      const formattedEndDate = endDate ? endDate.split('-').reverse().join('/') : '';

      if (formattedStartDate && formattedEndDate) {
        buttonText = `${formattedStartDate} - ${formattedEndDate}`;
      } else if (formattedStartDate) {
        buttonText = `Desde: ${formattedStartDate}`;
      } else if (formattedEndDate) {
        buttonText = `Hasta: ${formattedEndDate}`;
      } else {
        buttonText = "Seleccionar";
      }

      // NO llamar a requestSubmit() aquí para las fechas.
      // La validación y el submit para las fechas solo ocurren al hacer clic en "Aplicar" o "Volver".

    } else { // Para todos los demás tipos de filtros (radio buttons, etc.)
      button = document.querySelector(`button[data-param="${paramName}"]`);
      const selectedInput = this.element.querySelector(`input[name="${paramName}"][value="${paramValue}"]`);
      if (selectedInput) {
        const labelElement = selectedInput.closest('div').querySelector('label');
        if (paramName === 'prestador_proveedor') {
          if (selectedInput.id.startsWith('prestador_')) {
            buttonText = `Prestador: ${labelElement.textContent}`;
          } else if (selectedInput.id.startsWith('proveedor_')) {
            buttonText = `Proveedor: ${labelElement.textContent}`;
          } else {
            buttonText = labelElement.textContent;
          }
        } else {
          buttonText = labelElement.textContent;
        }
      } else {
        buttonText = "Seleccionar";
      }

      // Para radio buttons, etc., sí queremos que el formulario se envíe inmediatamente
      // para aplicar el filtro al cambiar la opción.
      // if (this.form) {
      //   this.form.requestSubmit();
      // }
    }

    if (button && buttonText !== undefined) {
        while (button.firstChild) {
          button.removeChild(button.firstChild);
        }
        const newText = document.createTextNode(buttonText);
        button.appendChild(newText);
        const newIcon = document.createElement('i');
        newIcon.className = 'fa-solid fa-chevron-right';
        button.appendChild(newIcon);
    }
  }
}